import { createFileRoute, redirect } from "@tanstack/react-router";
import type { JSX } from "react";
import ProjectsListPage from "@/components/settings/projects/projects-list-page";
import { isAdmin, toPermissionUser } from "@/lib/permissions";
import stores from "@/lib/stores";

const ProjectsTemplatesPage = (): JSX.Element => <ProjectsListPage kind="template" />;

export const Route = createFileRoute("/_app/settings/projects/templates/")({
	beforeLoad: () => {
		const user = toPermissionUser(stores.user.useStore.getState().value);
		if (!(user && isAdmin(user))) {
			throw redirect({ to: "/settings/projects" });
		}
	},
	component: ProjectsTemplatesPage,
});
